<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
    max-width: none !important;
}

.not-developer-praent {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.not-developer-div {
    padding: 1.5rem;
    width: fit-content;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    text-align: center;

    p {
        font-size: 1rem;
        color: #333;
        margin-bottom: 1rem;
    }
}

/* ===== Main Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 16px;
    }
}

/* ===== Mobile Card List ===== */
.includes-card-list {
    display: none;
    flex-direction: column;
    gap: 12px;

    .includes-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-plugin-name {
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .mobile-field {
        display: flex;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
        line-height: 30px;
    }

    .mobile-value {
        flex: 1;
        min-width: 0;
    }

    .mobile-card-foot {
        display: flex;
        gap: 8px;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
        flex-wrap: wrap;
    }
}

/* ===== Price Table in Modal ===== */
.price-modal-desc {
    padding: 8px 12px;
    background: #f6ffed;
    border-radius: 4px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #389e0d;
}

.price-table-pc,
.agent-price-table-pc,
.add-price-table-pc {
    margin-top: 12px;
}

.modal-note {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {
    .ant-layout-content {
        padding: 12px !important;
    }

    /* Toggle */
    .includes-table-pc {
        display: none !important;
    }

    .includes-card-list {
        display: flex !important;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 12px;
    }

    .not-developer-div {
        padding: 1rem;
    }
}

/* Very small phones */
@media screen and (max-width: 480px) {
    .ant-layout-content {
        padding: 8px !important;
    }
}
</style>
<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <div v-if="isDeveloper == 0" class="not-developer-praent">
                        <div class="not-developer-div">
                            <p>您还不是开发者，暂时无法查看本页面喔~</p>
                            <div style="text-align: center; width: fit-content; margin: 1rem auto 0.5rem;">
                                <a-button type="primary" @click="goApiUrl">成为开发者</a-button>
                            </div>
                        </div>
                    </div>

                    <a-card v-if="isDeveloper == 1" :bordered="false" class="table-card">
                        <template #title>
                            <div style="font-weight: 600;">插件管理</div>
                        </template>

                        <!-- PC端主表格 -->
                        <a-table class="includes-table-pc" :data-source="includesList" :pagination="false" row-key="id"
                            :scroll="{ x: 1400 }" size="small" bordered :columns="includesColumns">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'name'">
                                    <a-input v-model:value="record.name" style="width: 140px;" :maxlength="8"></a-input>
                                </template>
                                <template v-else-if="column.key === 'include_desc'">
                                    <a-input v-model:value="record.include_desc" :maxlength="150" style="width: 240px;"
                                        type="textarea" :rows="3" placeholder="请输入插件介绍" />
                                </template>
                                <template v-else-if="column.key === 'price'">
                                    <a-button type="primary" size="small" @click="getPrice(record.id)">查看/修改</a-button>
                                </template>
                                <template v-else-if="column.key === 'agentPrice'">
                                    <a-button type="primary" size="small"
                                        @click="getAgentPrice(record.id)">查看/修改</a-button>
                                </template>
                                <template v-else-if="column.key === 'is_Whole'">
                                    <a-radio-group v-model:value="record.is_Whole">
                                        <a-radio :value="1">支持</a-radio>
                                        <a-radio :value="0">不支持</a-radio>
                                    </a-radio-group>
                                </template>
                                <template v-else-if="column.key === 'is_Share'">
                                    <a-radio-group v-model:value="record.is_Share">
                                        <a-radio :value="1">通用</a-radio>
                                        <a-radio :value="0">独立</a-radio>
                                    </a-radio-group>
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <a-button type="primary" size="small" @click="saveIncludes(record)">保存</a-button>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="includes-card-list" v-if="includesList && includesList.length > 0">
                            <a-card v-for="record in includesList" :key="record.id" class="includes-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <span class="mobile-plugin-name">插件 #{{ record.id }} {{ record.name }}</span>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">插件名</span>
                                        <span class="mobile-value">
                                            <a-input v-model:value="record.name" :maxlength="8"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">介绍</span>
                                        <span class="mobile-value">
                                            <a-input v-model:value="record.include_desc" :maxlength="150"
                                                type="textarea" :auto-size="{ minRows: 2, maxRows: 4 }"></a-input>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">泛域名</span>
                                        <span class="mobile-value">
                                            <a-radio-group v-model:value="record.is_Whole">
                                                <a-radio :value="1">支持</a-radio>
                                                <a-radio :value="0">不支持</a-radio>
                                            </a-radio-group>
                                        </span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">类型</span>
                                        <span class="mobile-value">
                                            <a-radio-group v-model:value="record.is_Share">
                                                <a-radio :value="1">通用</a-radio>
                                                <a-radio :value="0">独立</a-radio>
                                            </a-radio-group>
                                        </span>
                                    </div>
                                </div>
                                <div class="mobile-card-foot">
                                    <a-button type="primary" size="small" @click="saveIncludes(record)">保存</a-button>
                                    <a-button size="small" @click="getPrice(record.id)">授权价格</a-button>
                                    <a-button size="small" @click="getAgentPrice(record.id)">代理价格</a-button>
                                </div>
                            </a-card>
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 授权价格查看/修改 -->
    <a-modal v-model:open="centerDialog.isShow" title="授权价格查看/修改" :width="900" :footer="null" centered>
        <!-- Version Tabs -->
        <div v-if="Object.keys(price_meal.versions).length > 1">
            <a-tabs v-model:activeKey="price_meal.active_version">
                <a-tab-pane v-for="(version_data, version_key) in price_meal.versions" :key="version_key"
                    :tab="version_data.name">
                </a-tab-pane>
            </a-tabs>
        </div>

        <!-- Version Description -->
        <div v-if="price_meal.versions[price_meal.active_version] && price_meal.versions[price_meal.active_version].desc"
            class="price-modal-desc">
            {{ price_meal.versions[price_meal.active_version].desc }}
        </div>

        <a @click="addPriceDialogFun(getActivePriceMeal()[0]?.grade_conf.includes_id, price_meal.active_version)"
            style="color: #1677ff; cursor: pointer; font-size: 13px;">新增价格规则</a>

        <!-- 价格表 -->
        <a-table class="price-table-pc" :data-source="getActivePriceMeal()" :pagination="false"
            row-key="grade_conf.grade" size="small" bordered :columns="priceColumns">
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'grade'">
                    <strong>{{ record.grade_conf.grade_name }}</strong>
                </template>
                <template v-else-if="column.key === 'actions'">
                    <a-button danger size="small"
                        @click="deletePriceDialog(getActivePriceMeal()[0].time_price[0].meal_id, record.grade_conf.includes_id)">
                        删除首个套餐
                    </a-button>
                </template>
                <template v-else-if="column.key && column.key.startsWith('tp_')">
                    <a-input-number :style="{ width: '80px' }"
                        v-model:value="record.time_price[getPriceIndex(column.key)].price"
                        @change="updatePrice(record.time_price[getPriceIndex(column.key)].meal_price_id, record.time_price[getPriceIndex(column.key)].price, price_meal.active_version)" />
                </template>
            </template>
        </a-table>
        <a-empty v-if="getActivePriceMeal().length === 0" description="暂无价格数据" />
        <div class="modal-note">---您可以修改相关价格---</div>
        <div style="text-align: right; margin-top: 16px;">
            <a-button @click="centerDialog.isShow = false">关闭</a-button>
        </div>
    </a-modal>

    <!-- 代理价格查看/修改 -->
    <a-modal v-model:open="agentDialog.isShow" title="代理价格查看/修改" :width="1000" :footer="null" centered>
        <a-table class="agent-price-table-pc" :data-source="agentPrice" :pagination="false" row-key="grade" size="small"
            bordered>
            <a-table-column data-index="grade_name" label="代理名称" width="140">
                <template #bodyCell="{ record }">
                    <a-input :maxlength="10" v-model:value="record.grade_name"></a-input>
                </template>
            </a-table-column>
            <a-table-column data-index="grade" label="等级" width="80" align="center" />
            <a-table-column label="开通价格" width="140">
                <template #bodyCell="{ record }">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <a-input-number :min="0" v-model:value="record.price" style="width: 80px;"></a-input-number>
                        <span>元</span>
                    </div>
                </template>
            </a-table-column>
            <a-table-column label="可开下级" width="140">
                <template #bodyCell="{ record }">
                    <a-radio-group v-model:value="record.open_lower_agent">
                        <a-radio :value="1">支持</a-radio>
                        <a-radio :value="0">不支持</a-radio>
                    </a-radio-group>
                </template>
            </a-table-column>
            <a-table-column label="下级升级返利" width="150">
                <template #bodyCell="{ record }">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <a-input-number :min="0" :max="100" v-model:value="record.rebate_ratio"
                            style="width: 80px;"></a-input-number>
                        <span>%</span>
                    </div>
                </template>
            </a-table-column>
            <a-table-column label="操作" width="100" align="center">
                <template #bodyCell="{ record }">
                    <a-button type="primary" size="small" @click="saveAgent(record)">保存</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-empty v-if="agentPrice.length === 0" description="暂无代理价格数据" />
        <div class="modal-note">---您可以修改相关价格---</div>
        <div style="text-align: right; margin-top: 16px;">
            <a-button @click="agentDialog.isShow = false">关闭</a-button>
        </div>
    </a-modal>

    <!-- 新增授权价格 -->
    <a-modal v-model:open="addPriceDialog.isShow" title="新增授权价格" :width="800" :footer="null" centered>
        <div class="add-price-wrapper">
            <a-table class="add-price-table-pc" :data-source="addPriceDialog.timeList" :pagination="false"
                row-key="meal_id" size="small" bordered :columns="addPriceColumns">
                <template #bodyCell="{ column, record, index }">
                    <template v-if="column.key === 'meal'">
                        <strong>{{ record.time_unit }}</strong>
                    </template>
                    <template v-else-if="column.key === 'actions'">
                        <a-button type="primary" size="small"
                            @click="addPriceFun(addPriceDialog.gradeTimePrice[index])">新增</a-button>
                    </template>
                    <template v-else-if="column.key && column.key.startsWith('grade_')">
                        <span style="margin-right: 4px;">{{ getGradeName(column.key) }}</span>
                        <a-input-number :min="0" style="width: 80px;"
                            v-model:value="addPriceDialog.gradeTimePrice[index].gradeList[getGradeIndex(column.key)].price" />
                        <span style="margin-left: 4px;">元</span>
                    </template>
                </template>
            </a-table>
            <a-empty v-if="addPriceDialog.timeList.length === 0" description="没有可添加的时间套餐" />
        </div>
        <div style="text-align: right; margin-top: 16px;">
            <a-button @click="addPriceDialog.isShow = false">关闭</a-button>
        </div>
    </a-modal>
</template>
<script>
import { defineComponent, ref, computed } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isLogin, isNull, compareDates, openBox } from "@/utils/publicMethods"
import { message, Modal } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            isDeveloper: 2,
            deveploerConf: {
                apiUrl: ""
            },
            includesList: "",
            includesColumns: [
                { title: '插件ID', dataIndex: 'id', key: 'id', width: 80, align: 'center' },
                { title: '插件名', dataIndex: 'name', key: 'name', width: 170 },
                { title: '插件介绍', dataIndex: 'include_desc', key: 'include_desc', width: 260 },
                { title: '授权价格', key: 'price', width: 120, align: 'center' },
                { title: '代理价格', key: 'agentPrice', width: 120, align: 'center' },
                { title: '支持泛域名', key: 'is_Whole', width: 120, align: 'center' },
                { title: '插件类型', key: 'is_Share', width: 100, align: 'center' },
                { title: '操作', key: 'action', width: 80, align: 'center' },
            ],
            centerDialog: {
                isShow: false,
            },
            price_meal: {
                versions: {},
                active_version: 1
            },
            agentDialog: {
                isShow: false
            },
            agentPrice: [],
            addPriceDialog: {
                isShow: false,
                timeList: [],
                gradeList: [],
                gradeTimePrice: []
            },
        }
    },
    computed: {
        priceColumns() {
            const meals = this.getActivePriceMeal();
            if (meals.length === 0 || meals[0].time_price.length === 0) {
                return [{ title: '暂无价格数据', key: 'empty', align: 'center' }];
            }
            const cols = [{ title: '用户类型', dataIndex: 'grade_conf.grade_name', key: 'grade', width: 140 }];
            meals[0].time_price.forEach((tp, i) => {
                cols.push({ title: tp.time_unit, key: 'tp_' + i, align: 'center', width: 100 });
            });
            return cols;
        },
        addPriceColumns() {
            const cols = [{ title: '时长', key: 'meal', width: 80, align: 'center' }];
            if (this.addPriceDialog.gradeList && this.addPriceDialog.gradeList.length > 0) {
                this.addPriceDialog.gradeList.forEach((g, i) => {
                    cols.push({ title: g.gradeName, key: 'grade_' + i, align: 'center', width: 200 });
                });
            }
            cols.push({ title: '操作', key: 'actions', width: 80, align: 'center' });
            return cols;
        }
    },
    methods: {
        getPriceIndex(key) {
            return parseInt(key.replace('tp_', ''));
        },
        getGradeIndex(key) {
            return parseInt(key.replace('grade_', ''));
        },
        getGradeName(key) {
            const idx = this.getGradeIndex(key);
            if (this.addPriceDialog.gradeList && this.addPriceDialog.gradeList[idx]) {
                return this.addPriceDialog.gradeList[idx].gradeName;
            }
            return '';
        },
        goApiUrl() {
            location.href = this.deveploerConf.apiUrl;
        },
        getIncludes() {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + '/dev/getIncludes', { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.isDeveloper = 1;
                        this.includesList = res.data.data;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    // message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveIncludes(row) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/updateIncludes', JSON.stringify(row), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                        this.isDeveloper = 1;
                        this.includesList = res.data.data;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        getActivePriceMeal() {
            const activeVersion = this.price_meal.active_version;
            if (this.price_meal.versions[activeVersion]) {
                return this.price_meal.versions[activeVersion].meals;
            }
            return [];
        },
        getPrice(id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("includes_id", id.toString())
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 200) {
                        const versions_data = res.data.data.data;

                        this.price_meal = {
                            versions: {},
                            active_version: 1
                        };

                        versions_data.forEach((version_item, index) => {
                            const version_name = version_item.version_name || `版本 ${index + 1}`;
                            const version_key = version_item.version;

                            this.price_meal.versions[version_key] = {
                                name: version_name,
                                desc: version_item.version_desc || '',
                                meals: []
                            };

                            version_item.grade_arr.forEach(grade_item => {
                                this.price_meal.versions[version_key].meals.push({
                                    grade_conf: grade_item.grade_conf,
                                    time_price: grade_item.time_price.slice().sort((a, b) => {
                                        return a.meal_id - b.meal_id;
                                    }),
                                })
                            });

                            this.price_meal.versions[version_key].meals.sort((a, b) => {
                                return a.grade_conf.grade - b.grade_conf.grade;
                            });
                        });

                        this.centerDialog.isShow = true
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取价格表失败：' + err.message)
                })
        },
        getAgentPrice(id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + "/dev/getGradePrice?includesId=" + id, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 200) {
                        var agentPrice = res.data.data
                        agentPrice.slice().sort(function (a, b) {
                            return a.grade - b.grade;
                        })
                        this.agentPrice = agentPrice;
                        this.agentDialog.isShow = true
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取价格表失败：' + err.message)
                })
        },
        updatePrice(id, price) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            let data = {
                mealPriceId: id,
                price: price
            }
            axios.post(baseURL + '/dev/updateTimePrice', JSON.stringify(data), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)

                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        saveAgent(agentData) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/saveAgentConf', JSON.stringify(agentData), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)

                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addPriceDialogFun(id, version = 0) {
            this.addPriceDialog.isShow = true;
            this.addPriceDialog.version = version;
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.get(baseURL + '/dev/getCanAddTimeMeal?includesId=' + id + "&version=" + version, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        let timeList = res.data.data.timeList;
                        let gradeList = res.data.data.gradeList;
                        if (timeList.length == 0) {
                            message.error("已经没有可添加的时间套餐")
                            this.addPriceDialog.isShow = false;
                            return;
                        }
                        this.addPriceDialog.timeList = timeList;
                        this.addPriceDialog.gradeList = gradeList;
                        let gradeTimePriceTemp = [];
                        for (let i = 0; i < timeList.length; i++) {
                            const timeItem = timeList[i];
                            let timeTemp = {
                                mealId: timeItem.meal_id,
                                includesId: id,
                                gradeList: []
                            }
                            for (let j = 0; j < gradeList.length; j++) {
                                const gradeItem = gradeList[j];
                                let gradeTemp = {
                                    grade: gradeItem.grade,
                                    price: 0
                                }
                                timeTemp.gradeList.push(gradeTemp);
                            }
                            gradeTimePriceTemp.push(timeTemp);
                        }
                        this.addPriceDialog.gradeTimePrice = gradeTimePriceTemp;
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        addPriceFun(data) {
            data.version = this.addPriceDialog.version;
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.post(baseURL + '/dev/addTimePrice', JSON.stringify(data), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                        this.addPriceDialog.isShow = false;
                        this.getPrice(data.includesId);
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        deletePriceDialog(meal_id, includes_id) {
            Modal.confirm({
                title: 'Warning',
                content: '确定删除该套餐？该操作无法撤销！',
                okText: '确认',
                cancelText: '取消',
                okType: 'warning',
                onOk: () => {
                    this.deletePrice(meal_id, includes_id)
                },
                onCancel: () => {
                    console.log();
                }
            })
        },
        deletePrice(meal_id, includes_id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }
            axios.get(baseURL + '/dev/deleteTimePrice?mealId=' + meal_id + '&IncludesId=' + includes_id + "&version=" + this.price_meal.active_version, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                        this.getPrice(includes_id);
                    } else if (res.data.code == 403) {
                        this.isDeveloper = 0;
                        this.deveploerConf.apiUrl = res.data.data;
                        openBox(this.deveploerConf.apiUrl)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);

                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getIncludes()
    }
})
</script>
